/**
 * `getImageData` throws on a zero-sized canvas (e.g. text with zero font size),
 * such canvas just has no pixels to scan.
 */
function getPixels(canvas) {
  if (!canvas.width || !canvas.height) {
    return [];
  }

  return canvas
    .getContext('2d')
    .getImageData(0, 0, canvas.width, canvas.height)
    .data;
}

function getPositionTopMostPixel(canvas) {
  const data = getPixels(canvas);

  const devicePixelRatio = window.devicePixelRatio || 1;

  let topMostY = canvas.height;
  let topMostX = 0;

  let leftMostX = canvas.width;
  let leftMostY = 0;

  let rightMostX = 0;
  let rightMostY = 0;

  let bottomMostY = 0;
  let bottomMostX = 0;

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const a = data[i + 3];

    if (a === 0) continue;
    if (r === 255 && g === 255 && b === 255) continue;
    
    const pixelIndex = i / 4;
    const x = pixelIndex % canvas.width;
    const y = Math.floor(pixelIndex / canvas.width);

    if (y < topMostY) {
      topMostY = y;
      topMostX = x;
    }

    if (x < leftMostX) {
      leftMostX = x;
      leftMostY = y;
    }

    if (x > rightMostX) {
      rightMostX = x;
      rightMostY = y;
    }

    if (y > bottomMostY) {
      bottomMostY = y;
      bottomMostX = x;
    }
  }

  return {
    topMostX: Math.floor(topMostX / devicePixelRatio),
    topMostY: Math.floor(topMostY / devicePixelRatio),
    leftMostX: Math.floor(leftMostX / devicePixelRatio),
    leftMostY: Math.floor(leftMostY / devicePixelRatio),
    rightMostX: Math.floor(-(rightMostX - canvas.width) / devicePixelRatio),
    rightMostY: Math.floor(-(rightMostY - canvas.height) / devicePixelRatio),
    bottomMostX: Math.floor(-(bottomMostX - canvas.width) / devicePixelRatio),
    bottomMostY: Math.floor(-(bottomMostY - canvas.height) / devicePixelRatio),
  };
}

export async function calculateTopMostPixels(fontFamily, fontSize, text) {
  const fabricText = new fabric.Text(text, {
    left: 0,
    top: 0,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fill: '#000000'
  });

  const textBoundingRect = fabricText.getBoundingRect();

  const canvas = new fabric.Canvas('canvas_'+text, {
    backgroundColor: '#FFFFFF',
    selection: false,
    height: Math.ceil(textBoundingRect.height),
    width: Math.ceil(textBoundingRect.width),
  });

  canvas.add(fabricText);
  canvas.renderAll();

  return getPositionTopMostPixel(canvas.lowerCanvasEl);
}
